







import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "TitleWithSubheading",
  props: {
    subheader: { type: String },
  },
});
